var isCordova = function isCordova() {
  return typeof window != "undefined" && (typeof window.PhoneGap != "undefined" || typeof window.Cordova != "undefined" || typeof window.cordova != "undefined");
};

export default isCordova;


//////////////////
// WEBPACK FOOTER
// ./node_modules/tus-js-client/lib.esm/browser/isCordova.js
// module id = 1199
// module chunks = 0